<template>
    <v-form ref="mfilesSettForm">
      <v-row align="center" justify="center">
        <h3><b>{{$t('json.mfiles')}}</b></h3>
      </v-row>
      <v-row align="center" justify="center">
        <v-col :cols="7">
          <!-- <v-text-field autocomplete="off"  @change="onChange" :label="$t('json.simendpoint')" v-model="EndpointMFiles.Endpoint" :rules="[() => !!EndpointMFiles.Endpoint || $t('json.ruleempty')]" required validate-on-blur ></v-text-field> -->
          <v-text-field autocomplete="off"  @change="onChangeUser" :label="$t('json.mfiles_user')" v-model="user" required validate-on-blur ></v-text-field>
          <v-text-field @change="onChangePass" :label="$t('json.mfiles_pass')" @click:append="EndpointMFiles.showPass = !EndpointMFiles.showPass" :append-icon="useAppendIcon" :type="EndpointMFiles.showPass ? 'text' : 'password'" v-model="pass" required validate-on-blur ></v-text-field>
          <v-switch :disabled="disable || preview" @change="onChange" :label="$t('json.export_skip')" v-model="EndpointMFiles.SkipExportSettings"></v-switch>
          <!-- <v-text-field autocomplete="off"  @change="onChangeUser" :label="$t('json.simuser')" v-model="simUser" :rules="[(v) => !!v || $t('json.ruleempty')]" required validate-on-blur ></v-text-field>
          <v-text-field @change="onChangePass" :label="$t('json.simpass')" @click:append="SimSettings.showPass = !SimSettings.showPass" :append-icon="useAppendIconSim" :type="SimSettings.showPass ? 'text' : 'password'" v-model="simPass" :rules="[(v) => !!v || $t('json.ruleempty')]" required validate-on-blur ></v-text-field> -->
          <!-- <v-btn :disabled="(simUser + simPass).length === 0" @click="saveUP" block color="primary">{{ $t('json.saveup') }}</v-btn> -->
          <v-btn  @click="saveUP" block color="primary">{{ $t('json.saveup') }}</v-btn>
          <br/>
        </v-col>
      </v-row>
    </v-form>
</template>

<script>
export default {
  name: 'MFilesEndpointSettings',
  props: {
    EndpointMFiles: {
      type: Object
    },
    disable: {
      type: Boolean,
      default: false
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      user: '',
      pass: '',
      maxChunkSize: 2,
      initedPass: false
    }
  },
  computed: {
    useAppendIcon () {
      if (this.initedPass) return undefined
      return this.EndpointMFiles.showPass ? 'mdi-eye' : 'mdi-eye-off'
    }
  },
  mounted () {
    const cryptoUser = atob(this.EndpointMFiles.username)
    const cryptoPass = atob(this.EndpointMFiles.password)
    this.user = cryptoUser
    this.pass = cryptoPass
    // this.maxChunkSize = this.EndpointMFiles.
    if (this.pass) this.initedPass = true
    console.log('MFILES SETTINGS', this.user, this.initedPass)
  },
  methods: {
    async onChangeUser (val) {

    },
    async onChangePass (val) {
      if (!this.pass) {
        this.initedPass = false
      }
    },
    async saveUP () {
      this.EndpointMFiles.username = btoa(this.user)
      this.EndpointMFiles.password = btoa(this.pass)
      this.$emit('changeSettings')
    },
    async onChange (val) {
      this.$emit('changeSettings')
    }
  }
}
</script>
